export enum InputType {
  Integer = 'integer',
  Number = 'number',
  Letters = 'letters',
  Alphanumeric = 'alphanumeric',
  AlphanumericAndSymbols = 'alphanumericAndSymbols',
  AlphanumericAndSpace = 'alphanumericAndSpace',
  TIN = 'TIN',
  SSN = 'SSN',
  Phone = 'Phone',
  Decimal = 'decimal',
  LettersAndSpace = 'lettersAndSpace',
}
